import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Unstable_Grid2 as Grid } from '@mui/material';

import { Loaders } from 'components';

interface Props {
  working: boolean;
}

const styles = {
  container: {
    paddingTop: 3,
  },
} as const;

const Actions: FC<Props> = ({ working }) => {
  const navigate = useNavigate();
  const { submitForm } = useFormikContext();
  const { t } = useTranslation();

  return (
    <Grid container justifyContent="flex-end" sx={styles.container}>
      <Grid marginRight={2}>
        <Button variant="contained" size="large" color="secondary" onClick={() => navigate(-1)}>
          {t('common:cancel')}
        </Button>
      </Grid>
      <Grid>
        <Button
          onClick={submitForm}
          size="large"
          disabled={working}
          type="submit"
          variant="contained"
          color="primary"
        >
          {working ? <Loaders.Standard height={26} /> : t('common:send')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default Actions;
